import React from 'react';
import './Technologies.css';

function Services() {
  return (
   <>
  <header className='skills-header'>Skilled In</header>


<section className="skills collection">
        <div className="cskills-ontainer">
          <ul className="skills-list has-scrollbar">
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://bs-uploads.toptal.io/blackfish-uploads/components/blog_post_page/4085627/cover_image/regular_1708x683/01-HTML5_CM-d750fc9cb7c10219f11c708c75450e79.png')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://colorlib.com/wp/wp-content/uploads/sites/2/creative-css3-tutorials.jpg')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://media.licdn.com/dms/image/C4E12AQEBVCR2SpRr9g/article-cover_image-shrink_720_1280/0/1625909824541?e=2147483647&v=beta&t=Y_zSoI8cPUR3wQvPyYK15PLWpQJJ0si6OvsuXFnIC18')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://cdn.shopaccino.com/igmguru/articles/What-Is-React-Native.png?v=491')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://cloud.z.com/vn/wp-content/uploads/2024/07/figma.png')" }}
              >
                <a href="#" className="btn btn-secondary">
                 
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://www.webfx.com/wp-content/uploads/2022/08/github-logo.png')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://i.ibb.co/8D0T3q1/crud-nodejs.jpg')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
            <li>
              <div
                className="skills-card"
                style={{ backgroundImage: "url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-_he2uTblTMpBkL5BWa1LHLY-ZpPRgRrhWU3aFB7RZ2G4hY1dzVa14dH60rRSSHYknqQ&usqp=CAU')" }}
              >
                <a href="#" className="btn btn-secondary">
                  <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </section>

   </>

  )
}

export default Services